import { api } from '@api/api2';

export const getCameras = () => api.v1('post', 'cameras/get-by-company');
